module.exports = __webpack_public_path__ + "img/treasuries-transactions.1695a4fa.svg";